import { create } from "zustand";

interface ProductionLineUIState {
  selectedLineId: string | null;
  selectedWorkCenterId: string | null;
  setSelectedLine: (id: string | null) => void;
  setSelectedWorkCenter: (id: string | null) => void;
}

/**
 * ADR-100: local UI-only state for the Production Line management screen
 * (which line / work center is currently selected in the master-detail
 * layout). Server state (lines, work centers, machines) is owned by React
 * Query via api.ts — this store intentionally holds nothing that the
 * server already owns, per project convention.
 */
export const useProductionLineUIStore = create<ProductionLineUIState>((set) => ({
  selectedLineId: null,
  selectedWorkCenterId: null,
  setSelectedLine: (id) => set({ selectedLineId: id, selectedWorkCenterId: null }),
  setSelectedWorkCenter: (id) => set({ selectedWorkCenterId: id }),
}));
